import Table, { TableProps } from '@ui-components-3/ui/lib/components/Table'
import { TableModel } from '@ui-components-3/ui/lib/components/Table/types'
import classNames from '@ui-components-3/ui/lib/utils/classNames'
import flexRender from '@ui-components-3/ui/lib/components/Table/utils/flexRender'

const Footer = () => (
  <Table.Footer key="footer">
    <div className="gap-xs ml-auto flex flex-wrap justify-end">
      <Table.RowsPerPage />
      <Table.Pagination />
    </div>
  </Table.Footer>
)

type ClientPaginationTableProps = {
  model: TableModel
  onRowClick?: (r: any) => void
  emptyStateClassName?: string
  cellClassName?: string
  renderEmptyState?: () => React.ReactNode
  dummyRowsLength?: number
  cellContext?: Record<string, Record<string, any>>
} & TableProps

const PaginatedTable = ({
  model,
  cellClassName,
  onRowClick,
  dummyRowsLength,
  emptyStateClassName,
  renderEmptyState,
  cellContext,
  ...props
}: ClientPaginationTableProps) => {
  return (
    <Table colorVariant="secondary" variant="striped" footer={<Footer />} {...props} model={model}>
      <Table.Header>
        {model.getFlatHeaders().map(({ column, getContext }) => {
          const context = getContext()
          const isVisible = column.getIsVisible()
          return isVisible ? (
            <Table.Column key={`header:${column.id}`} id={column.id} className="whitespace-nowrap">
              <div className="gap-xs flex items-center">
                {flexRender(column.columnDef.header, context)}
                {column.columnDef.enableSorting ? <Table.ColumnSorter id={column.id} /> : null}
              </div>
            </Table.Column>
          ) : null
        })}
      </Table.Header>
      <Table.Body renderEmptyState={renderEmptyState ?? (() => <Table.EmptyBody className={emptyStateClassName} />)}>
        {model.isLoading ? (
          <Table.DummyRows length={dummyRowsLength} />
        ) : (
          model.getRowModel().rows.map((row) => (
            <Table.Row id={row.id} key={`row:${row.id}`} onAction={() => onRowClick?.(row)}>
              {row.getVisibleCells().map((cell) => {
                const additionalContext = cellContext?.[cell.column.id] || {}
                return (
                  <Table.Cell
                    key={`cell:${cell.id}`}
                    className={classNames((cell.column.columnDef?.meta as any)?.cellClassName, cellClassName)}
                  >
                    {flexRender(cell.column.columnDef.cell, { ...cell.getContext(), ...additionalContext })}
                  </Table.Cell>
                )
              })}
            </Table.Row>
          ))
        )}
      </Table.Body>
    </Table>
  )
}

export default PaginatedTable
